// 表示順・表示用番号・数値/文字列の違いを除いて、保存された選択内容を比較する。
export function selectionSignature(key: string, value: any): string {
  if (["shakenShurui", "inspectLineCd", "liftUse", "jizenCd"].indexOf(key) >= 0) {
    return String(value == null ? "" : value);
  }
  if (key === "kensain" || key === "seibishi" || key === "hojoSeibishi") {
    return JSON.stringify((value || []).map((item: any) => String(item.staffCd)).sort());
  }
  const fields: { [key: string]: string[] } = {
    option: ["optionId", "renban", "optionNm", "kingakuZn", "kingakuZk",
      "warrantyKbn", "isInport", "kijunCd", "periodCd", "tireCd"],
    coupon: ["couponId", "renban", "couponNm", "couponZn", "couponZk"],
    proposal: ["proposalId", "proposalNm"],
    tokuten: ["tokutenId", "tokutenNm"]
  };
  return JSON.stringify((value || [])
    .filter((item: any) => item.isCheck === true || item.isCheck === 1 || item.isCheck === "1")
    .map((item: any) => fields[key].map(field => {
      const v = item[field];
      return v == null ? "" : String(typeof v === "boolean" ? (v ? 1 : 0) : v);
    }))
    .map((item: string[]) => JSON.stringify(item)).sort());
}

export class InspectionSelectionSync {
  private saved: { [key: string]: string } = {};

  remember(key: string, value: any) {
    this.saved[key] = selectionSignature(key, value);
  }

  // サーバーが未変更ならローカル入力を維持。競合時を含め、サーバー変更時のみ反映する。
  changed(key: string, value: any): boolean {
    return this.saved[key] !== selectionSignature(key, value);
  }
}

// 旧BEの通知はnullを返して従来の再取得へ。別の整備種別のコースも直接反映しない。
export function readSelectionSnapshot(body: any, sknSeibiShubetsuKbn: number): any {
  const selection = body && body.selection;
  if (!selection || String(body.sknSeibiShubetsuKbn) !== String(sknSeibiShubetsuKbn)
      || !Object.prototype.hasOwnProperty.call(selection, "shakenShuruiSeibiMenuCd")) { return null; }
  if (!["inspectLineCd", "liftUse", "jizenCd", "kensain", "seibishi", "hojoSeibishi"]
      .every(key => Object.prototype.hasOwnProperty.call(selection, key))) { return null; }
  const option = selection.optionData;
  const coupon = selection.couponData;
  if (!option || !option.option || !Array.isArray(option.option.items) || !coupon
      || !["coupon", "proposal", "tokuten"].every(key => coupon[key] && Array.isArray(coupon[key].items))) {
    return null;
  }
  return { detail: selection, option, coupon };
}

// 顧客側の編集用Storeでも、サーバーが変わっていない領域の入力を残す。
export function mergeSelectionSections(previous: any, current: any, incoming: any, keys: string[]): any {
  const result = { ...incoming };
  let keepLocalInput = false;
  keys.forEach(key => {
    if (previous && selectionSignature(key, previous[key] && previous[key].items)
        === selectionSignature(key, incoming[key] && incoming[key].items)) {
      result[key] = current[key];
      if (selectionSignature(key, current[key] && current[key].items)
          !== selectionSignature(key, previous[key] && previous[key].items)) {
        keepLocalInput = true;
      }
    }
  });
  if (keepLocalInput) {
    result.isConfirm = current.isConfirm;
    result.waitAutoSave = current.waitAutoSave;
  }
  return result;
}
